import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=79321738&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
import style0 from "./Preview.vue?vue&type=style&index=0&id=79321738&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79321738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79321738')) {
      api.createRecord('79321738', component.options)
    } else {
      api.reload('79321738', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=79321738&scoped=true", function () {
      api.rerender('79321738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/Preview.vue"
export default component.exports